module.exports = __webpack_public_path__ + "img/ic-download.16302df3.svg";